const escapeHtml = (text) =>
  text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const highlight = (text, searchQuery) => {
  if (!text) {
    return "";
  }

  if (!searchQuery) {
    return escapeHtml(text);
  }

  let lt = text.toLowerCase();
  let ls = searchQuery.toLowerCase().trim();
  let firstMatchIndex = lt.indexOf(ls);

  if (firstMatchIndex < 0) {
    return escapeHtml(text);
  }

  let startPos = 0;
  let endPos = firstMatchIndex + ls.length + 500;

  if (endPos >= lt.length) {
    endPos = lt.length;
  }

  let snippet = text.substring(startPos, endPos);
  let snippetStartPos = snippet.toLowerCase().indexOf(ls);

  let result = escapeHtml(snippet.substring(0, snippetStartPos));
  result += "<span class='highlight'>" + escapeHtml(snippet.substring(snippetStartPos, snippetStartPos + ls.length)) + "</span>";
  result += escapeHtml(snippet.substring(snippetStartPos + ls.length, snippet.length));

  return result;
};

const filter = (rows, query, attribs) => {
  if (!query) return rows;

  let lowerQuery = query.toLowerCase();

  return rows.filter(f => {
    return (
      attribs.filter(a => {
        return f[a] && f[a].toLowerCase().indexOf(lowerQuery) >= 0;
      }).length > 0
    );
  });
};

export default { highlight, filter };
